import { z } from 'zod';

export const createRecommendationSchema = z.object({
  short_content: z.string().min(1, 'Short content is required'),
  deep_content: z.string().min(1, 'Deep content is required'),
  threshold_min: z.number().min(0).max(100).nullable(),
  threshold_max: z.number().min(0).max(100).nullable(),
  category_id: z.string().min(1, 'Category ID is required'),
});

export type CreateRecommendationPayload = z.infer<typeof createRecommendationSchema>;
